import { getController, apiService as Service } from '@/services/service'

const url = 'teams'

export const teamService = {
	...getController<Api.Team, Api.TeamPostInput, Api.TeamUpdateInput>(url),
	deadlines: (id: number) => Service.get({ url: `${url}/${id}/deadlines` }),
}

export default teamService
